import {
  normalizeManifestCurrency,
  normalizeManifestI18n,
  normalizeManifestLocale,
  normalizeManifestWithMarket,
} from "./manifestI18nCore.js";
import {
  getLocaleUrlSegment,
  localeToOpenGraphLocaleTag,
  normalizeRegistryLocale,
  resolveUrlSegmentToLocale,
} from "./localeRegistry.js";

export {
  MANIFEST_I18N_LOCALES,
  MANIFEST_I18N_CURRENCIES,
  DEFAULT_MANIFEST_I18N,
  normalizeManifestLocale,
  normalizeManifestCurrency,
  normalizeManifestI18n,
  normalizeManifestWithMarket,
  normalizeManifestMarket,
  resolveManifestMarket,
  getMarketProfileForManifest,
} from "./manifestI18nCore.js";

export function getManifestI18n(manifest) {
  const market = manifest?.market;
  return normalizeManifestI18n(manifest?.i18n, market ? { code: market.code || market.marketCode } : null);
}

export function getManifestMarket(manifest) {
  return normalizeManifestWithMarket(manifest).market;
}

export function localeToUrlSegment(locale, manifestI18n = null) {
  const normalized = normalizeManifestLocale(locale);
  if (manifestI18n?.supportedLocales && !manifestI18n.supportedLocales.includes(normalized)) {
    return null;
  }
  return getLocaleUrlSegment(normalized);
}

export function parseUrlLocaleSegment(segment, manifestI18n = null) {
  return resolveUrlSegmentToLocale(segment, manifestI18n);
}

export function isUrlLocaleSegment(segment, manifestI18n = null) {
  return parseUrlLocaleSegment(segment, manifestI18n) != null;
}

export function localeToOpenGraphLocale(locale) {
  return localeToOpenGraphLocaleTag(locale);
}

export function isLocaleSupportedByManifest(locale, manifestI18n) {
  return manifestI18n.supportedLocales.includes(normalizeRegistryLocale(locale));
}

export function isCurrencySupportedByManifest(currency, manifestI18n) {
  return manifestI18n.supportedCurrencies.includes(normalizeManifestCurrency(currency));
}
